import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { useResponsivePropValue } from '../../hooks';
import { createDataTestId } from '../../utils';
import { SkeletonVariant } from './Skeleton.constants';
import { SkeletonRoot } from './Skeleton.styles';
export function Skeleton(_ref) {
  let {
    variant = SkeletonVariant.TEXT,
    height,
    width,
    testId
  } = _ref;
  const heightResolved = useResponsivePropValue(height);
  const widthResolved = useResponsivePropValue(width);
  return React.createElement(SkeletonRoot, _extends({
    variant: variant,
    width: widthResolved,
    height: heightResolved
  }, createDataTestId(testId), {
    "data-component": "Skeleton"
  }));
}